import { Box, CircularProgress, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Popover, Tab } from '@mui/material';
import * as React from 'react';
import { BozpDocumentNewsResponseDTO, BozpDocumentNewsType, EmployeeMobileVovClient, SetBozpAsReadEmployeeMobileRequest, SetDocumentAsReadEmployeeMobileRequest, SetDocumentAsRejectedEmployeeMobileRequest, SetNewsAsReadEmployeeMobileRequest } from '../../../ApiOld/Api/ApiServerVov';
import { useMobileApi } from '../../../Api/Mobile/useMobileApi';
import { useTranslation } from 'react-i18next';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import MobileDocumentsDetailTab from './MobileDocumentsDetailTab';
import MobileDocumentFileDetail from './MobileDocumentFileDetail';
import { useEmployeeContext } from '../../../Contexts/Providers/EmployeeLayoutProvider';
import MobileDocumentsSignature from './Components/MobileDocumentsSignature';
import { useCallback } from 'react';
import { FilterList, NotificationsNone, ReportProblem, TextSnippet } from '@mui/icons-material';

export interface IMobileDocumentsTabsProps {
}

export enum DocumentFilter {
    All = 1,
    Documents,
    Bozps,
    News,
}

export default function MobileDocumentsTabs(props: IMobileDocumentsTabsProps) {
    const { authorizedMobileEmployeeApi } = useMobileApi(EmployeeMobileVovClient);
    const [documentData, setDocumentData] = React.useState<BozpDocumentNewsResponseDTO[]>([]);
    const [selectedDocument, setSelectedDocument] = React.useState<BozpDocumentNewsResponseDTO>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [signatureOpen, setSignatureOpen] = React.useState<boolean>(false);

    const [documents, setDocuments] = React.useState<boolean>(true);
    const [bozps, setBozps] = React.useState<boolean>(true);
    const [news, setNews] = React.useState<boolean>(true);

    const [isOpen, setIsOpen] = React.useState<boolean>(false);

    const { t } = useTranslation();
    const { setModuleButton, setModuleName, setModuleSecondButton } = useEmployeeContext();

    React.useEffect(() => {
        refreshData();
    }, []);
    React.useEffect(() => {
        refreshData();
    }, [documents, bozps, news]);

    React.useEffect(() => {
        setModuleButton && setModuleButton(null);
        setModuleSecondButton && setModuleSecondButton(moduleSecondButtonContent());
    }, [isOpen, setModuleButton, setModuleSecondButton, t]);

    const refreshData = useCallback(() => {
        setLoading(true);
        setDocumentData([]);
        authorizedMobileEmployeeApi.getAllBozpDocumentNewsEmployeeMobile(documents, bozps, news).then((res) => {
            setDocumentData(res?.bozpDocumentNews ?? []);
            setLoading(false);
        });
    }, [authorizedMobileEmployeeApi, setDocumentData, setLoading, documents, bozps, news]);

    const [value, setValue] = React.useState('1');

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    const handleRead = (doc: BozpDocumentNewsResponseDTO) => {
        console.log(doc);
        setSelectedDocument(doc);
        if (doc.type === BozpDocumentNewsType.Bozp)
            setSignatureOpen(true);
    }

    const getHelperText = useCallback(() => {
        if (documentData.filter(p => !p.isRead).length > 0) {
            return t('beforeContinueRead') + ' ' + documentData.filter(p => !p.isRead).length + ' ' + t('unreadDocuments');
        }
        return undefined;
    }, [documentData, t]);

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
        setIsOpen(true);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setIsOpen(false);
    };

    const handleOptionClick = (option: DocumentFilter) => {
        switch (option) {
            case DocumentFilter.All:
                setDocuments(true);
                setBozps(true);
                setNews(true);
                break;
            case DocumentFilter.Documents:
                setDocuments(true);
                setBozps(false);
                setNews(false);
                break;
            case DocumentFilter.Bozps:
                setDocuments(false);
                setBozps(true);
                setNews(false);
                break;
            case DocumentFilter.News:
                setDocuments(false);
                setBozps(false);
                setNews(true);
                break;
        }
        handleClose();
    };



    const moduleSecondButtonContent = React.useCallback(() => (
        <div>
            <IconButton onClick={handleOpen} sx={{ position: 'absolute', right: 0, top: 4 }}>
                <FilterList />
            </IconButton>
            <Popover
                open={isOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <List>
                    <ListItem key={'all'} disablePadding>
                        <ListItemButton onClick={() => handleOptionClick(DocumentFilter.All)}>
                            <ListItemIcon>
                                <FilterList />
                            </ListItemIcon>
                            <ListItemText primary={t('All')} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={'bozps'} disablePadding>
                        <ListItemButton onClick={() => handleOptionClick(DocumentFilter.Bozps)}>
                            <ListItemIcon>
                                <ReportProblem />
                            </ListItemIcon>
                            <ListItemText primary={t('bozp')} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={'docs'} disablePadding>
                        <ListItemButton onClick={() => handleOptionClick(DocumentFilter.Documents)}>
                            <ListItemIcon>
                                <TextSnippet />
                            </ListItemIcon>
                            <ListItemText primary={t('Documents')} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={'news'} disablePadding>
                        <ListItemButton onClick={() => handleOptionClick(DocumentFilter.News)}>
                            <ListItemIcon>
                                <NotificationsNone />
                            </ListItemIcon>
                            <ListItemText primary={t('dashboard.news')} />
                        </ListItemButton>
                    </ListItem>
                </List>
            </Popover>
        </div>
    ), [handleOpen, isOpen, anchorEl, handleClose, handleOptionClick, t]);

    return (
        <Box sx={{ width: '100%', typography: 'body1', display: 'flex', flexDirection: 'column', height: 'calc(100vh - 56px)' }}>
            {!selectedDocument && <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList
                        sx={{
                            backgroundColor: '#FFC600',
                            color: 'black',
                            '& .Mui-selected': {
                                color: 'black',
                            },
                            '& .MuiTabs-indicator': {
                                backgroundColor: 'black',
                            },
                        }}
                        onChange={handleChange}
                        aria-label="mobile-documents-tabs"
                    >
                        <Tab label={t('unread')} value="1" sx={{ flex: 1, color: 'black !important' }} />
                        <Tab label={t('signed')} value="2" sx={{ flex: 1, color: 'black !important' }} />
                        <Tab label={t('rejected')} value="3" sx={{ flex: 1, color: 'black !important' }} />
                    </TabList>
                </Box>
                <Box sx={{ flex: 1, overflowY: 'auto' }}>
                    <TabPanel value="1">
                        {!loading && <MobileDocumentsDetailTab data={documentData?.filter(p => !p.isRead) ?? []} onClick={handleRead} helperText={getHelperText()} />}
                        {loading && <CircularProgress />}
                    </TabPanel>
                    <TabPanel value="2">
                        {!loading && <MobileDocumentsDetailTab data={documentData?.filter(p => p.isRead && !p.isRejected) ?? []} onClick={handleRead} />}
                        {loading && <CircularProgress />}
                    </TabPanel>
                    <TabPanel value="3">
                        {!loading && <MobileDocumentsDetailTab data={documentData?.filter(p => p.isRead && p.isRejected) ?? []} onClick={handleRead} />}
                        {loading && <CircularProgress />}
                    </TabPanel>
                </Box>
            </TabContext>}
            {selectedDocument && selectedDocument.type !== BozpDocumentNewsType.Bozp && <MobileDocumentFileDetail item={selectedDocument}
                onRejectClick={() => {
                    authorizedMobileEmployeeApi.setDocumentAsRejectedEmployeeMobile(new SetDocumentAsRejectedEmployeeMobileRequest({ documentId: selectedDocument.id, documentType: selectedDocument.type?.toString() })).then((res) => {
                        console.log(res);
                        if (res.ok) {
                            const index = documentData.findIndex(p => p.id === selectedDocument.id);
                            documentData[index].isRejected = true;
                            setDocumentData([...documentData]);
                            setSelectedDocument(undefined);
                            refreshData();
                        }
                    })
                }}
                onSignClick={() => {
                    setSignatureOpen(true);
                }}
                onClose={() => {
                    setModuleButton && setModuleButton(null);
                    setModuleSecondButton && setModuleSecondButton(moduleSecondButtonContent());
                    setModuleName(t('Documents'));
                    setSelectedDocument(undefined);
                }} />}
            {selectedDocument && <MobileDocumentsSignature data={selectedDocument}
                onSigned={(sign) => {
                    if (selectedDocument.type === BozpDocumentNewsType.Document)
                        authorizedMobileEmployeeApi.setDocumentAsReadEmployeeMobile(new SetDocumentAsReadEmployeeMobileRequest({ documentId: selectedDocument.id, documentType: selectedDocument.type?.toString(), signature: sign })).then((res) => {
                            console.log(res);
                            if (res.ok) {
                                setSelectedDocument(undefined);
                                setSignatureOpen(false);
                                refreshData();
                            }
                        })
                    else if (selectedDocument.type === BozpDocumentNewsType.Bozp)
                        authorizedMobileEmployeeApi.setBozpAsReadEmployeeMobile(new SetBozpAsReadEmployeeMobileRequest({ bozpId: selectedDocument.id, signature: sign })).then((res) => {
                            console.log(res);
                            if (res.ok) {
                                setSelectedDocument(undefined);
                                setSignatureOpen(false);
                                refreshData();
                            }
                        })
                    else if (selectedDocument.type === BozpDocumentNewsType.News)
                        authorizedMobileEmployeeApi.setNewsAsReadEmployeeMobile(new SetNewsAsReadEmployeeMobileRequest({ newId: selectedDocument.id, signature: sign })).then((res) => {
                            console.log(res);
                            if (res.ok) {
                                setSelectedDocument(undefined);
                                setSignatureOpen(false);
                                refreshData();
                            }
                        })
                }}
                open={signatureOpen} onClose={() => { setSignatureOpen(false); setSelectedDocument(undefined); }} />}
        </Box>);
}
